export interface Entity {
  //Kinda of overloading this as a base interface
  id: number;
  name: string;
  firstName?: string;
}

export enum EntityIDMap {
  System = 1,
  Tenant = 2,
  User = 3,
  Property = 4,
  Property_Group = 5,
  Truck = 6,
  Job = 7,
  Permission = 8,
  Violation = 9,
  Rule = 10,
  Ruleset = 11,
  Contact = 12,
  Vehicle = 13,
  Permit = 14,
  Payment = 15,
  Tenant_Group = 16,
  Permit_Type = 17,
  Pricing = 18,
}

export enum EntityTypes {
  None = "none",
  System = "system",
  Permission = "permission",
  Tenant = "tenant",
  TenantGroup = "tenant_group",
  Property = "property",
  PropertyGroup = "property_group",
  User = "user",
  Truck = "truck",
  Job = "job",
  Rule = "rule",
  Ruleset = "ruleset",
  Violation = "violation",
  Contact = "contact",
  Vehicle = "vehicle",
  Permit = "permit",
  Payment = "payment",
  PermitType = "permit_type",
  Pricing = "pricing",
}

export const ENTITIES: Array<Entity> = [
  { id: EntityIDMap.System, name: EntityTypes.System },
  { id: EntityIDMap.Tenant, name: EntityTypes.Tenant },
  { id: EntityIDMap.User, name: EntityTypes.User },
  { id: EntityIDMap.Property, name: EntityTypes.Property },
  { id: EntityIDMap.Property_Group, name: EntityTypes.PropertyGroup },
  { id: EntityIDMap.Truck, name: EntityTypes.Truck },
  { id: EntityIDMap.Job, name: EntityTypes.Job },
  { id: EntityIDMap.Permission, name: EntityTypes.Permission },
  { id: EntityIDMap.Violation, name: EntityTypes.Violation },
  { id: EntityIDMap.Rule, name: EntityTypes.Rule },
  { id: EntityIDMap.Ruleset, name: EntityTypes.Ruleset },
  { id: EntityIDMap.Contact, name: EntityTypes.Contact },
  { id: EntityIDMap.Vehicle, name: EntityTypes.Vehicle },
  { id: EntityIDMap.Permit, name: EntityTypes.Permit },
  { id: EntityIDMap.Payment, name: EntityTypes.Payment },
  { id: EntityIDMap.Tenant_Group, name: EntityTypes.TenantGroup },
  { id: EntityIDMap.Permit_Type, name: EntityTypes.PermitType },
  { id: EntityIDMap.Pricing, name: EntityTypes.Pricing },
];
